import * as ST from './styled';

interface IProps {
    icon: string,
    title: string,
    text: string,
}

const ShopItemElement = ({ icon, title, text }: IProps) => {
    return (
        <ST.Wrapper data-test='shopItem-element'>
            <ST.Icon iconSrc={icon} data-test='shopItem-element-icon'/>
            <ST.DescWrap>
                <ST.Title data-test='shopItem-element-title' title={title}>{title}</ST.Title>
                <ST.Text data-test='shopItem-element-text' title={text}>{text}</ST.Text>
            </ST.DescWrap>
        </ST.Wrapper>
    );
};

export default ShopItemElement;
